import { CIcon } from '~/icons/types'
export const ciMileage: CIcon = {
  width: 512,
  height: 351,
  paths: [
    {
      d:
        'M501.5 350.7c-4.5 0-8.7-2.9-10.1-7.5L391.1 13.9c-1.7-5.6 1.4-11.4 7-13.1 5.6-1.7 11.4 1.4 13.1 7L511.5 337c1.7 5.6-1.4 11.4-7 13.1-1 .4-2 .6-3 .6zm-491 0c-1 0-2.1-.1-3.1-.5-5.6-1.7-8.7-7.6-7-13.1L100.8 7.8c1.7-5.6 7.6-8.7 13.1-7 5.6 1.7 8.7 7.6 7 13.1L20.6 343.2c-1.4 4.5-5.5 7.5-10.1 7.5zM256 86c-5.8 0-10.5-4.7-10.5-10.5v-35c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v35c0 5.8-4.7 10.5-10.5 10.5zm0 113.5c-5.8 0-10.5-4.7-10.5-10.5v-55.1c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5V189c0 5.8-4.7 10.5-10.5 10.5zm0 137.6c-5.8 0-10.5-4.7-10.5-10.5v-75.1c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v75.1c0 5.8-4.7 10.5-10.5 10.5z'
    }
  ],
  name: 'mileage',
  type: 'regular'
}
